import { useTranslation } from 'react-i18next';

import { BoxModelEditor } from '../controls/BoxModelEditor';
import { NumberInput } from '../controls/NumberInput';
import type { LayoutElementStyle } from '../styleTypes';

interface SpacingSectionProps {
  style: LayoutElementStyle;
  onChange: (updates: Partial<LayoutElementStyle>) => void;
}

export function SpacingSection({ style, onChange }: SpacingSectionProps) {
  const { t } = useTranslation();
  const pt = typeof style.paddingTop === 'number' ? style.paddingTop : undefined;
  const pr = typeof style.paddingRight === 'number' ? style.paddingRight : undefined;
  const pb = typeof style.paddingBottom === 'number' ? style.paddingBottom : undefined;
  const pl = typeof style.paddingLeft === 'number' ? style.paddingLeft : undefined;
  const mt = typeof style.marginTop === 'number' ? style.marginTop : undefined;
  const mr = typeof style.marginRight === 'number' ? style.marginRight : undefined;
  const mb = typeof style.marginBottom === 'number' ? style.marginBottom : undefined;
  const ml = typeof style.marginLeft === 'number' ? style.marginLeft : undefined;

  return (
    <div className="space-y-4">
      {/* Visual Box Model */}
      <BoxModelEditor
        paddingTop={pt}
        paddingRight={pr}
        paddingBottom={pb}
        paddingLeft={pl}
        marginTop={mt}
        marginRight={mr}
        marginBottom={mb}
        marginLeft={ml}
        onPaddingChange={(side, val) => {
          const key =
            `padding${side.charAt(0).toUpperCase() + side.slice(1)}` as keyof LayoutElementStyle;
          onChange({ [key]: val });
        }}
        onMarginChange={(side, val) => {
          const key =
            `margin${side.charAt(0).toUpperCase() + side.slice(1)}` as keyof LayoutElementStyle;
          onChange({ [key]: val });
        }}
      />

      {/* Gap */}
      <NumberInput
        value={style.gap}
        onChange={(v) => onChange({ gap: v })}
        min={0}
        max={100}
        label={t('tenant.systemModuleBuilder.style.spacing.gap')}
        unit="px"
      />
    </div>
  );
}
